import { oz, type ValueOf } from '@weft/utils';

export const ZAPI_TARGETS = Object.freeze({
  HTTP_CLIENT: 'httpClient',
  AWS_APIGATEWAY: 'awsApigateway',
  EXTERNAL_AWS_APIGATEWAY: 'externalAwsApigateway',
  DOCUMENTATION: 'documentation',
});

export const ZapiTargetSchema = oz.nativeEnum(ZAPI_TARGETS);

export type ZapiTarget = ValueOf<typeof ZAPI_TARGETS>;